// Versão do app - gerado automaticamente
export const APP_VERSION = '5.35'
export const BUILD_DATE = '10/05/2026, 15:31'
